import React from 'react';

import { CardControlLoader, Piwik } from '../types';
import { SavedMessage, SavingFailedMessage, SavingMessage } from './saveStatusMessage';

interface StatusProps {
    cardControlLoader: CardControlLoader;
    piwik: Piwik | undefined;
}

const StatusMessage = ({ cardControlLoader, piwik }: StatusProps) => {
    const { isPostingCardControl, hasPostedCardControl, failedPostingCardControl } = cardControlLoader;

    if (isPostingCardControl) {
        return (
            <SavingMessage
                data-track-id={piwik?.regionBlockEcommerce?.regionBlockSaving?.dataTrackId}
                data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockSaving?.dataTrackLinkname}
                id={piwik?.regionBlockEcommerce?.regionBlockSaving?.dataTrackId}
            />
        );
    }

    if (failedPostingCardControl) {
        return (
            <SavingFailedMessage
                data-track-id={piwik?.regionBlockEcommerce?.regionBlockSaveFail?.dataTrackId}
                data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockSaveFail?.dataTrackLinkname}
                id={piwik?.regionBlockEcommerce?.regionBlockSaveFail?.dataTrackId}
            />
        );
    }

    if (hasPostedCardControl) {
        return (
            <SavedMessage
                data-track-id={piwik?.regionBlockEcommerce?.regionBlockSaved?.dataTrackId}
                data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockSaved?.dataTrackLinkname}
                id={piwik?.regionBlockEcommerce?.regionBlockSaved?.dataTrackId}
            />
        );
    }

    return null;
};

export default (props: StatusProps) => (
    <div className="status-container">
        <StatusMessage {...props} />
    </div>
);
